var frameThrottle = require("enyo-perf/utils").frameThrottle,
    kind          = require("enyo/kind");

require("./PlaylistHeader.less");

module.exports = kind(/** @lends app.PlaylistPage.PlaylistHeader.prototype */ {

    /**
     * @private
     */
    name: "app.PlaylistPage.PlaylistHeader",

    /**
     * @private
     */
    classes: "app-playlist-page-playlist-header",

    /**
     * @private
     */
    tag: "thead",

    /**
     * The state of this page.
     *
     * @type  {?Object}
     * @public
     */
    data: null,

    /**
     * @private
     */
    components: [{
        tag:        "tr",
        classes:    "app-playlist-page-playlist-header__row",
        components: [{
            classes: "app-playlist-page-playlist-header__left-spacer",
            tag:     "th"
        }, {
            name:    "number",
            classes: "app-playlist-page-playlist-header__number",
            tag:     "th"
        }, {
            name:    "thumbnail",
            classes: "app-playlist-page-playlist-header__thumbnail",
            tag:     "th"
        }, {
            name:    "title",
            classes: "app-playlist-page-playlist-header__title",
            tag:     "th"
        }, {
            name:       "duration",
            classes:    "app-playlist-page-playlist-header__duration",
            tag:        "th",
            attributes: {
                colspan: 2
            }
        }, {
            classes: "app-playlist-page-playlist-header__right-spacer",
            tag:     "th"
        }]
    }, {
        tag:        "tr",
        classes:    "app-playlist-page-playlist-header__spacer",
        components: [{
            tag:        "th",
            attributes: {
                colspan: 7
            }
        }]
    }],

    /**
     * @private
     */
    observers: {
        update: ["data"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.observe("app.$.i18nService.translation", this.update);
            this.update();
        };
    }),

    /**
     * @protected
     */
    update: function() {
        var $i18nService = this.app.$.i18nService;

        this.$.number.set("content", $i18nService.getString("app.PlaylistPage.Playlist.Header.number"));
        this.$.title.set("content", $i18nService.getString("app.PlaylistPage.Playlist.Header.title"));
        this.$.duration.set("content", $i18nService.getString("app.PlaylistPage.Playlist.Header.duration"));
    }
});
